<template>
  <div>
    <bg-video/>
    <div id="app">
      <logo/>
      <router-view></router-view>
      <app-footer/>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo';
import BgVideo from '@/components/BgVideo';
import AppFooter from '@/components/AppFooter';

export default {
  components: {Logo, BgVideo, AppFooter},
  name: 'app'
};
</script>

<style>
body {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
}

a {
  color: #fff;
}

a:visited {
  color: #fefefe;
}

#app {
  background: rgba(0,0,0,0.6);
  max-width: 1024px;
  margin: auto;
  color: #c0c0c0;
  text-align: center;
  padding: 2em;
}
</style>



// WEBPACK FOOTER //
// App.vue?fa88ed7e